import { ICancelSubscriptionDTO } from '../../../dtos/cancelSubscriptionDTO';
import { ISingleSubscription } from '../../../models/subscriptions/single_subscription.model';
import { ISubscriptions } from '../../../models/subscriptions/subscriptions.model';
import { SubscriptionType } from './action.creator';

export type SubscriptionAction = {
    type: string;
    payload?: any;
};

export const getAllSubscriptions = (data: any): SubscriptionAction => {
    return {
        type: SubscriptionType.GET_SUBSCRIPTIONS,
        payload: data
    };
};

export const getAllSubscriptionFailure = (error: string): SubscriptionAction => {
    return {
        type: SubscriptionType.GET_SUBSCRIPTIONS_FAILURE,
        payload: error
    };
};

export const setAllSubscriptions = (data: ISubscriptions): SubscriptionAction => {
    return {
        type: SubscriptionType.GET_SUBSCRIPTIONS_SUCCESS,
        payload: data
    };
};

export const getSingleSubscription = (data: any): SubscriptionAction => {
    return {
        type: SubscriptionType.GET_SINGLE_SUBSCRIPTION,
        payload: data
    };
};

export const getSingleSubscriptionSuccess = (data: ISingleSubscription): SubscriptionAction => {
    return {
        type: SubscriptionType.GET_SINGLE_SUBSCRIPTION_SUCCESS,
        payload: data
    };
};

export const getSingleSubscriptionFailure = (error: string): SubscriptionAction => {
    return {
        type: SubscriptionType.GET_SINGLE_SUBSCRIPTION_FAILURE,
        payload: error
    };
};

export const cancelSubscription = (data: ICancelSubscriptionDTO): SubscriptionAction => {
    return {
        type: SubscriptionType.CANCEL_SUBSCRIPTION,
        payload: data
    };
};

export const cancelSubscriptionSuccess = (data: string): SubscriptionAction => {
    return {
        type: SubscriptionType.CANCEL_SUBSCRIPTION_SUCCESS,
        payload: data
    };
};

export const cancelSubscriptionFailure = (error: string): SubscriptionAction => {
    return {
        type: SubscriptionType.CANCEL_SUBSCRIPTION_FAILURE,
        payload: error
    };
};

export const clearCancelSubscriptionState = (): SubscriptionAction => {
    return {
        type: SubscriptionType.CLEAR_CANCEL_SUBSCRIPTION_STATE
    };
};
